import type { DeleteResponse } from '@/entities/delete-reponse';
import type { PaginatedResponse } from '@/entities/pagination/paginated-response';
import type {
  CreateWorkshopAppointmentDocumentDto,
  UpdateWorkshopAppointmentDocumentDto,
  WorkshopAppointmentDocumentDto,
  WorkshopAppointmentsControllerFindAllWorkshopAppointmentDocumentsData,
} from '@carvia/ros-client-types';
import { httpClient } from './http-client';

class WorkshopAppointmentDocumentsService {
  httpClient = httpClient;
  endpoint = '/workshop-appointments/';
  subEndpoint = '/documents';

  async getAllPaginated(
    workshopAppointmentId: string,
    params: WorkshopAppointmentsControllerFindAllWorkshopAppointmentDocumentsData['query'],
  ) {
    const res = await this.httpClient.get<PaginatedResponse<WorkshopAppointmentDocumentDto>>(
      `${this.endpoint}${workshopAppointmentId}${this.subEndpoint}`,
      { params },
    );
    return res.data;
  }

  async getOne(workshopAppointmentId: string, documentId: string) {
    const res = await this.httpClient.get<WorkshopAppointmentDocumentDto>(
      `${this.endpoint}${workshopAppointmentId}${this.subEndpoint}/${documentId}`,
    );
    return res.data;
  }

  async update(
    workshopAppointmentId: string,
    documentId: string,
    data: UpdateWorkshopAppointmentDocumentDto,
  ) {
    const res = await this.httpClient.patch<WorkshopAppointmentDocumentDto>(
      `${this.endpoint}${workshopAppointmentId}${this.subEndpoint}/${documentId}`,
      data,
    );
    return res.data;
  }

  async create(workshopAppointmentId: string, data: CreateWorkshopAppointmentDocumentDto) {
    const res = await this.httpClient.post<WorkshopAppointmentDocumentDto>(
      `${this.endpoint}${workshopAppointmentId}${this.subEndpoint}`,
      data,
    );
    return res.data;
  }

  async remove(workshopAppointmentId: string, documentId: string) {
    const res = await this.httpClient.delete<DeleteResponse>(
      `${this.endpoint}${workshopAppointmentId}${this.subEndpoint}/${documentId}`,
    );
    return res.data;
  }
}

export const workshopAppointmentDocumentsService = new WorkshopAppointmentDocumentsService();
